// Fragments are not sent in HTTP requests/referrers. Reject redirects, query
// parameters and lookalike hosts; never persist these one-use secrets.
export function accountActionLink(value){
 if(typeof value!=='string'||value.length>250)return null;
 let fragment=value;
 if(!value.startsWith('#')){try{const u=new URL(value);if(u.origin!=='https://app.qtracker.dk'||u.pathname!=='/'||u.search||u.username||u.password)return null;fragment=u.hash;}catch{return null;}}
 const match=fragment.match(/^#account-(verify|reset)=([A-Za-z0-9_-]{32})$/);
 return match?{purpose:match[1],token:match[2]}:null;
}
